import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var ColBootstrap = function (_a) {
    var children = _a.children, breakPoint = _a.breakPoint, col = _a.col;
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "col-".concat(breakPoint, "-").concat(col), children: children }) }));
};
